import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReferencesCmsComponents } from '@core/const';
import { ProductFeatureModule } from '@product/feature';
import { ProductCardNavigationModule } from '@sdvor/product/ui';
import { SdvorProductItemComponent, SdvorProductItemSkeletonComponent } from '@sdvor/product/ui/v2';
import { InViewportDirective } from '@sdvor/shared/ui';
import { SdvorSwiperComponent } from '@sdvor/shared/ui/v2';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { RetailRocketReferencesComponent } from './retail-rocket-references.component';

@NgModule({
  declarations: [RetailRocketReferencesComponent],
  imports: [
    NgClass,
    NgIf,
    AsyncPipe,
    ProductFeatureModule,
    ProductCardNavigationModule,
    SdvorProductItemComponent,
    SdvorProductItemSkeletonComponent,
    SdvorSwiperComponent,
    InViewportDirective,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [ReferencesCmsComponents.RetailRocketProductReferencesComponent]: {
          component: RetailRocketReferencesComponent,
        },
        [ReferencesCmsComponents.RetailRocketCartReferencesComponent]: {
          component: RetailRocketReferencesComponent,
        },
        [ReferencesCmsComponents.RetailRocketCatalogReferencesComponent]: {
          component: RetailRocketReferencesComponent,
        },
        [ReferencesCmsComponents.RetailRocketUserReferencesComponent]: {
          component: RetailRocketReferencesComponent,
        },
        [ReferencesCmsComponents.RetailRocketWishListReferencesComponent]: {
          component: RetailRocketReferencesComponent,
        },
        [ReferencesCmsComponents.RetailRocketComparisonReferencesComponent]: {
          component: RetailRocketReferencesComponent,
        },
      },
    }),
  ],
  exports: [RetailRocketReferencesComponent],
})
export class RetailRocketReferencesModule {}
